import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, X } from "lucide-react";

/**
 * Global paywall modal — listens to `mc:subscription-required` and shows
 * a friendly "Tu prueba gratuita terminó" splash with a CTA to /pricing.
 * Mounted once inside the app shell so any 402 response surfaces it.
 */
export default function PaywallModal() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onGate = () => setOpen(true);
    window.addEventListener("mc:subscription-required", onGate);
    return () => window.removeEventListener("mc:subscription-required", onGate);
  }, []);

  if (!open) return null;
  return (
    <div className="cc-modal-overlay" onClick={() => setOpen(false)} data-testid="paywall-modal">
      <div className="cc-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 460 }}>
        <header>
          <div className="cc-modal-icon" style={{ background: "#fef3c7", color: "#b45309" }}><Lock size={22} /></div>
          <div>
            <small>PRUEBA TERMINADA</small>
            <h2>🔒 Tu prueba gratuita terminó</h2>
          </div>
          <button onClick={() => setOpen(false)} className="cc-modal-close" aria-label="Cerrar"><X size={18} /></button>
        </header>
        <div className="cc-modal-body">
          <p style={{ font: '500 15px/1.55 "Nunito", sans-serif', color: "#334155", margin: 0 }}>
            <b>Tu información sigue segura</b> y puedes seguir consultándola. Para continuar utilizando esta herramienta, elige el plan que mejor se adapte a ti.
          </p>
        </div>
        <footer>
          <button className="cc-btn ghost" onClick={() => setOpen(false)}>Ahora no</button>
          <button
            className="cc-btn primary"
            data-testid="paywall-view-plans"
            onClick={() => { setOpen(false); navigate("/trial-expired"); }}
          >
            Ver planes →
          </button>
        </footer>
      </div>
    </div>
  );
}
